var _path, _path2, _g, _path3, _path4, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoNoText = function SvgLogoNoText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.42 0H34.731v24.882H60V4.581A4.58 4.58 0 0 0 55.42 0Z",
    fill: "#F0AC00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0h25.268v24.882H0V0Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.268 0H4.581A4.581 4.581 0 0 0 0 4.58v20.302h25.268V0Z",
    fill: "#B7B7B7"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.42 60H34.731V35.118H60v20.301A4.58 4.58 0 0 1 55.42 60Z",
    fill: "#121212"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 35,
    width: 26,
    height: 25
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 35.118h25.268V60H0V35.118Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.268 60H4.581A4.581 4.581 0 0 1 0 55.42V35.117h25.268V60Z",
    fill: "#2762E9"
  }))));
};
export { SvgLogoNoText as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01NS40MTkyIDBIMzQuNzMyVjI0Ljg4MjRINTkuOTk5OFY0LjU4MDU4QzU5Ljk5OTggMi4wNTExOCA1Ny45NDkyIDAgNTUuNDE5MiAwWiIgZmlsbD0iI0YwQUMwMCIvPgo8bWFzayBpZD0ibWFzazBfMTI2XzM5OTAiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyNiIgaGVpZ2h0PSIyNSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAwSDI1LjI2ODJWMjQuODgyNEgwVjBaIiBmaWxsPSJ3aGl0ZSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMTI2XzM5OTApIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNS4yNjgxIDBINC41ODA5MUMyLjA1MDg3IDAgLTAuMDAwMzA1MTc2IDIuMDUxMTggLTAuMDAwMzA1MTc2IDQuNTgwNThWMjQuODgyNEgyNS4yNjgxVjBaIiBmaWxsPSIjQjdCN0I3Ii8+CjwvZz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01NS40MTkyIDYwSDM0LjczMlYzNS4xMTc3SDU5Ljk5OThWNTUuNDE5NUM1OS45OTk4IDU3Ljk0ODkgNTcuOTQ5MiA2MCA1NS40MTkyIDYwWiIgZmlsbD0iIzEyMTIxMiIvPgo8bWFzayBpZD0ibWFzazFfMTI2XzM5OTAiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjM1IiB3aWR0aD0iMjYiIGhlaWdodD0iMjUiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAgMzUuMTE3N0gyNS4yNjgyVjYwSDBWMzUuMTE3N1oiIGZpbGw9IndoaXRlIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMV8xMjZfMzk5MCkiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI1LjI2ODEgNjBINC41ODA5MUMyLjA1MDg3IDYwIC0wLjAwMDMwNTE3NiA1Ny45NDg5IC0wLjAwMDMwNTE3NiA1NS40MTk1VjM1LjExNzdIMjUuMjY4MVY2MFoiIGZpbGw9IiMyNzYyRTkiLz4KPC9nPgo8L3N2Zz4K";